import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line
import { Container, ContentWithPaddingXl } from "components/misc/Layouts.js";
import { SectionHeading } from "components/misc/Headings.js";
import { PrimaryButton as PrimaryButtonBase } from "components/misc/Buttons.js";
import { ReactComponent as SvgDecoratorBlob1 } from "images/svg-decorator-blob-5.svg";
import { ReactComponent as SvgDecoratorBlob2 } from "images/svg-decorator-blob-7.svg";
import { Link } from "react-router-dom";  // Import Link from react-router-dom

const HeaderRow = tw.div`flex justify-between items-center flex-col xl:flex-row`;
const Header = tw(SectionHeading)`
  text-[2.5rem] 
`;
const TabsControl = tw.div`
  flex flex-wrap justify-center gap-3 bg-gray-100 p-4 rounded-full shadow-md mt-10
`;

const TabControl = styled.div`
  ${tw`cursor-pointer px-5 py-2 rounded-full text-sm sm:text-base font-semibold transition duration-300 ease-in-out`}
  background-color: ${({ active }) => (active ? "#2c5a78" : "transparent")};
  color: ${({ active }) => (active ? "#fff" : "#2c5a78")};
  box-shadow: ${({ active }) => (active ? "0px 2px 10px rgba(0,0,0,0.1)" : "none")};
  border: 1px solid ${({ active }) => (active ? "#2c5a78" : "#d1d5db")};

  &:hover {
    background-color: ${({ active }) => (active ? "#2c5a78" : "#2c5a78")};
    color: ${({ active }) => (active ? "#fff" : "#1f2937")};
  }
`;


const TabContent = tw(motion.div)`mt-6 flex flex-wrap sm:-mr-10 md:-mr-6 lg:-mr-12`;
const CardContainer = tw.div`mt-10 w-full sm:w-1/2 md:w-1/3 lg:w-1/3 xl:w-1/3 sm:pr-10 md:pr-6 lg:pr-12`; 
const Card = tw(motion.a)`rounded-b block max-w-xs mx-auto sm:max-w-none sm:mx-0 mb-0`;  // Add mb-0 to remove margin-bottom
const CardImageContainer = styled.div`
  ${props => css`background-image: url("${props.imageSrc}");`}
  ${tw`h-56 xl:h-64 bg-center bg-cover relative rounded-t`}
`;
const CardHoverOverlay = styled(motion.div)`
  background-color: rgba(255, 255, 255, 0.5);
  ${tw`absolute inset-0 flex justify-center items-center`}
`;
const CardButton = tw(PrimaryButtonBase)`text-sm flex justify-center items-center mt-4`;
const CardButtonContainer = tw.div`
  flex justify-center items-center mt-2 w-auto  /* Reduced margin */
`;



const CardText = tw.div`p-4 text-gray-900`;
const CardTitle = tw.h5`
  text-sm font-bold text-center text-[#707070]  /* Adjust size to small, make it bold, and center */
`;

const CardContent = tw.p`
  mt-1 text-xs font-light text-center text-gray-600  /* Adjust size and font weight, and center */
`;
const CardPrice = tw.p`
  mt-2 text-base font-semibold text-center text-[#707070]  /* Reduced margin */
`;

const DecoratorBlob1 = styled(SvgDecoratorBlob1)`
  ${tw`pointer-events-none -z-20 absolute right-0 top-0 h-64 w-64 opacity-15 transform translate-x-2/3 -translate-y-12 text-pink-400`}
`;
const DecoratorBlob2 = styled(SvgDecoratorBlob2)`
  ${tw`pointer-events-none -z-20 absolute left-0 bottom-0 h-80 w-80 opacity-15 transform -translate-x-2/3 text-primary-500`}
`;

const ProductTabs = ({ heading = "Nos produits", tabs = { Alimentaire: [], Cosmetique: [] } }) => {
  const [productsAlimentaire, setProductsAlimentaire] = useState([]);
  const [cosmetique, setCosmetique] = useState([]);
  const role = localStorage.getItem("role"); // Assuming role is saved in localStorage
  // Fetch Alimentaire products
  useEffect(() => {
    fetch("https://hbmdijital.online/api/Produit-alimentaire")
      .then((response) => response.json())
      .then((data) => setProductsAlimentaire(Array.isArray(data) ? data : []))
      .catch((error) => console.error("Error fetching products alimentaire:", error));
  }, []);

  // Fetch Cosmetique products
  useEffect(() => {
    fetch("https://hbmdijital.online/api/cosmetique")
      .then((response) => response.json())
      .then((data) => setCosmetique(Array.isArray(data) ? data : []))
      .catch((error) => console.error("Error fetching products cosmetique:", error));
  }, []);

  const tabsContent = {
    Alimentaire: productsAlimentaire,
    Cosmetique: cosmetique,
  };
console.log(cosmetique);
  const tabsKeys = Object.keys(tabsContent);
  const [activeTab, setActiveTab] = useState(tabsKeys[0]);
  return (
    <Container>
      <ContentWithPaddingXl>
        <HeaderRow>
          <Header >{heading}</Header>
          <TabsControl>
            {tabsKeys.map((tabName, index) => (
              <TabControl key={index} active={activeTab === tabName} onClick={() => setActiveTab(tabName)}>
                {tabName}
              </TabControl>
            ))}
          </TabsControl>
        </HeaderRow>

        {tabsKeys.map((tabKey, index) => (
          <TabContent
            key={index}
            variants={{
              current: { opacity: 1, scale: 1, display: "flex" },
              hidden: { opacity: 0, scale: 0.8, display: "none" },
            }}
            transition={{ duration: 0.4 }}
            initial={activeTab === tabKey ? "current" : "hidden"}
            animate={activeTab === tabKey ? "current" : "hidden"}
          >
            {(tabsContent[tabKey] && Array.isArray(tabsContent[tabKey])) ? (
              tabsContent[tabKey].map((card, index) => (
                <CardContainer key={index}>
                <Link to={`/product-details/${card.ProductID}`}>
                  <Card className="group" initial="rest" whileHover="hover" animate="rest">
                    <CardImageContainer imageSrc={`https://hbmdijital.online/storage/${card.image}`} />
                    
                    <CardText>
                      <CardTitle>{card.Name}</CardTitle>
                      {/* <CardContent style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                        {card.Description}
                      </CardContent> */}
                      <CardPrice>
{card.Price} DH

                      </CardPrice>
                      <CardButtonContainer>
    <CardButton>Acheter maintenant</CardButton>
  </CardButtonContainer>
                    </CardText>
                    {/* <CardButtonContainer>
    <CardButton>Acheter maintenant</CardButton>
  </CardButtonContainer> */}
                  </Card>
      
                </Link>
              </CardContainer>
              
              
              ))
            ) : (
              <p>No products available</p>
            )}
          </TabContent>
        ))}
      </ContentWithPaddingXl>
      {/* <div tw="flex justify-center -mt-4">
  <Link to="/boutique">
    <PrimaryButtonBase>Nos Produits</PrimaryButtonBase>
  </Link>
</div> */}


      <DecoratorBlob1 />
      <DecoratorBlob2 />
    </Container>
  );
};

export default ProductTabs;
